import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { LOCAL_REQUEST_FEEDBACK } from './reporting-api.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentServices {

  constructor(
    private httpClient: HttpClient,
  ) { }

  httpOptions = {
    headers: new HttpHeaders({'Content-Type': 'application/json'})
  }
  
  payOrder(id:string){
    return this.httpClient.post(`${environment.apiUrl}TapPayment/create-payment-order`,`"${id}"`,this.httpOptions)
  }
  PaymentCallback(id:string){
    return this.httpClient.post(`${environment.apiUrl}TapPayment/payment-callback`,`"${id}"`,this.httpOptions)
  }

  payOffline(orderNumber:any,isCash : any){
    const url = `${environment.apiUrl}Payment/PayByPOS?isCash=${isCash}`;

    return this.httpClient.post(
      url, 
      JSON.stringify(orderNumber), // Correct JSON body format
      { ...this.httpOptions, context: new HttpContext().set(LOCAL_REQUEST_FEEDBACK, true) }
    );
  }

}
